import SeoServicePage from "@/pages/services/SeoServicePage";

const RootCanalPage = () => (
  <SeoServicePage
    slugOverride="root-canal-treatment-kalyan"
    canonicalOverride="/root-canal-kalyan"
    breadcrumbsOverride={[
      { label: "Advanced Treatments", path: "/services" },
      { label: "Root Canal Kalyan" },
    ]}
  />
);

export default RootCanalPage;